<script>
export default {
    data: () => ({
        itemNumber: '',
    }),
    methods: {
        setItemNumber(event) {
            this.itemNumber = event.target.value
        },
    },
    render() {
        return this.$scopedSlots.default({
            setItemNumber: this.setItemNumber,
            itemNumber: this.itemNumber,
        })
    },
}
</script>
